import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import {
    EditButton,
    translate,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import AvatarNameField from '../AvatarNameField';
import TrueValueField from '../TrueValueField';
import { isAdmin, isEditor } from '../permissions';

const listStyles = theme => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        margin: '0.5rem 0',
    },
    cardTitleContent: {
        display: 'flex',
        flexDirection: 'rows',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    cardContent: theme.typography.body1,
    cardContentRow: {
        display: 'flex',
        flexDirection: 'rows',
        alignItems: 'center',
        margin: '0.5rem 0',
    },
});

export const MobileGrid = ({permissions, classes, ids, data, basePath, translate}) => (
    <div style={{ margin: '1em' }}>
        {ids.map(id => (
            <Card key={id} className={classes.card}>
                <CardHeader
                    title={
                        <div className={classes.cardTitleContent}>
                            <span>
                                <AvatarNameField name={`${data[id].firstName} ${data[id].lastName}`} record={data[id]} />
                            </span>
                            {
                                (isAdmin(permissions) || isEditor(permissions)) &&
                                <EditButton
                                    resource="officials"
                                    basePath={basePath}
                                    record={data[id]}
                                />
                            }
                        </div>
                    }
                />
                <CardContent className={classes.cardContent}>
                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.standardPosition')} record={data[id]}  source="standardPosition" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.firstName')} record={data[id]}  source="firstName" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.lastName')} record={data[id]}  source="lastName" />


                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.birthDate')} record={data[id]}  source="birthDate" />


                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.weight')} record={data[id]}  source="weight" />


                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.height')} record={data[id]}  source="height" />


                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.nickName')} record={data[id]}  source="nickName" />


                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.birthPlace')} record={data[id]}  source="birthPlace" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.nationality')} record={data[id]}  source="nationality" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.preferredFoot')} record={data[id]}  source="preferredFoot" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.realPosition')} record={data[id]}  source="realPosition" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.realPositionSide')} record={data[id]}  source="realPositionSide" />

                    <TrueValueField className={classes.cardContentRow} label={translate('resources.player.fields.country')} record={data[id]}  source="country" />

                </CardContent>

            </Card>
        ))}
    </div>
);

const enhance = compose(
    withStyles(listStyles),
    translate
);

export default enhance(MobileGrid);